import { Fragment } from "react";

import { generatePath, Link, useParams } from "react-router-dom";

import fetcher_v2 from "@/api/fetcher_v2";
import TrashIcon from "@/assets/icons/trash.svg";
import { getSubscriberBadges } from "@/containers/SubscriberBadge";
import { useI18n } from "@/contexts/i18nContext";
import { ROUTES } from "@/routes_new";
import { cx } from "@/utils";
import AccessControl, { ACCESS_LEVELS } from "@components/AccessControl";
import Table from "@components/Table";
import TextButton from "@components/TextButton";

import styles from "./ReportList.module.css";

const ReportSubscriptionRows = (props) => {
  const TEMPLATE_NAME_MAP = {
    overview: L.REPORTS_TABLE_HEADERS_OVERVIEW,
    comparison_with_reach: L.REPORTS_TABLE_HEADERS_COMPARISON,
    time_comparison: L.REPORTS_TABLE_HEADERS_TIME_COMPARISON,
    blank: L.REPORTS_TABLE_HEADERS_BLANK,
    comparison_se: L.REPORTS_TABLE_HEADERS_COMPARISON,
  };

  const INTERVAL_TITLE_MAP = {
    daily: L.REPORTS_INTERVAL_DAILY,
    weekly: L.REPORTS_INTERVAL_WEEKLY,
    monthly: L.REPORTS_INTERVAL_MONTHLY,
    quarterly: L.REPORTS_INTERVAL_QUARTERLY,
    yearly: L.REPORTS_INTERVAL_YEARLY,
  };

  const onDeleteReport = (uuid) => {
    if (confirm(L.REPORTS_REPORT_DELETE_CONFIRM)) {
      props.deleteReportFromList(uuid);
      fetcher_v2(generatePath(ROUTES.REPORT, { uuid }), {
        method: "DELETE",
      })
        .then((response) => {
          if (response.ok) {
            props.setShouldReloadReports(true);
          }
        })
        .catch((error) => {
          throw error;
        });
    }
  };
  const { formatDate } = useI18n();
  const { orgUuid } = useParams();

  const reportsByTemplate = props?.data
    .map((r) =>
      r.template === "social_media_overview"
        ? { ...r, template: "overview" }
        : r
    )
    .reduce((all, report) => {
      if (all[report.template]) {
        all[report.template].push(report);
      } else {
        all[report.template] = [report];
      }
      return all;
    }, {});

  const grouped = Object.entries(reportsByTemplate);

  return grouped.map(([title, rows], i) => (
    <Fragment key={i}>
      <thead>
        <tr>
          <th>{TEMPLATE_NAME_MAP[title]}</th>
          <th>{L.REPORTS_LIST_HEADER_INTERVAL}</th>
          <AccessControl>
            <th className={styles.desktopOnly}>
              {L.REPORTS_LIST_HEADER_SUBSCRIBERS}
            </th>
          </AccessControl>
          <th className={styles.desktopOnly}>{L.REPORT_LAST_MODIFIED}</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr key={i} className={styles.tr}>
            <td className={styles.title}>
              <Link
                to={generatePath(ROUTES.REPORTS_EDIT_ORGID, {
                  orgUuid,
                  uuid: row.uuid,
                })}
              >
                {row.title}
              </Link>
            </td>
            <td>
              {row.interval === "monthly" &&
              (row.template === "overview" ||
                row.template === "social_media_overview")
                ? "-"
                : INTERVAL_TITLE_MAP[row.interval]}
            </td>
            <AccessControl>
              <td className={cx(styles.desktopOnly, styles.badges)}>
                {getSubscriberBadges(row.subscribers, 3, i)}
              </td>
            </AccessControl>
            <td className={styles.desktopOnly}>
              {formatDate(new Date(row.last_modified), "PPP")}
            </td>
            <td className={styles.buttons}>
              <AccessControl level={ACCESS_LEVELS.USER}>
                <TextButton
                  color="inherit"
                  icon={TrashIcon}
                  onClick={() => onDeleteReport(row.uuid)}
                />
              </AccessControl>
            </td>
          </tr>
        ))}
      </tbody>
    </Fragment>
  ));
};

export const ReportList = (props) => (
  <div data-testid="report-list" className={styles.row}>
    <div>
      <Table>
        <ReportSubscriptionRows {...props} />
      </Table>
    </div>
  </div>
);
